import moment from 'moment';
import React from 'react';

interface DeploymentStatusState {
  deploymentStatus: JSX.Element | string;
}

interface DeploymentStatusProps
  extends React.HtmlHTMLAttributes<HTMLSpanElement> {}

export class DeploymentStatus extends React.Component<
  DeploymentStatusProps,
  DeploymentStatusState
> {
  state: DeploymentStatusState = {
    deploymentStatus: '',
  };

  constructor(props: DeploymentStatusProps) {
    super(props);

    const formatString = 'Y/MM/DD \\a\\t HH:mm:ss ZZ';

    if (process.env.NODE_ENV === 'production') {
      const buildMoment = moment('2025-10-28T09:23:23Z');
      const deployedTimestamp = buildMoment.format(formatString);
      const deployedAgo = buildMoment.fromNow();
      const commitSha = '90a018a6';
      const commitLink = `https://gitlab.com/qbane/ascii-tree-utils/commit/${commitSha}`;

      this.state.deploymentStatus = (
        <span>
          Last deployed on {deployedTimestamp} ({deployedAgo}) for commit{' '}
          <a className="hide-offline" href={commitLink}>
            {commitSha}
          </a>
          <b className="hide-online">{commitSha}</b>
        </span>
      );
    } else {
      this.state.deploymentStatus = `Running locally. The current date is ${moment().format(
        formatString,
      )}`;
    }
  }

  render() {
    return this.state.deploymentStatus;
  }
}
